module.exports = __webpack_public_path__ + "static/media/livechat.b6f4e5a8.svg";